import script from "./BadgesRepository.vue?vue&type=script&lang=js"
export * from "./BadgesRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__